import { gql } from 'src/generated/gql';

export const CLAIMS_RESUBMIT_EVENT = gql(`
  mutation ClaimsResubmitEvent($eventId: ID!) {
    claimsResubmitEvent(eventId: $eventId)
  }
`);
